// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2008":"9dcd38f8","4949":"092e8f19","5531":"9dcd38f8"}[chunkId] + ".chunk.css";
};